import ControlProps from '../../../mixins/ControlProps';
import {
  MAX_LENGTH,
  MIN_LENGTH,
  DEFAULT_COLS,
  DEFAULT_ROWS,
} from '../constants';
import { TextareaPropertyType, TextAreaResizeType } from '../enums';
import { StyleColorSchemeType } from '../../../../../../styles/enums';
import { ControlStyleFillType } from '../../../enums';

const TextareaProps = {
  props: {
    ...ControlProps.props,
    [TextareaPropertyType.Rows]: {
      type: Number,
      default: DEFAULT_ROWS,
    },
    [TextareaPropertyType.Cols]: {
      type: Number,
      default: DEFAULT_COLS,
    },
    [TextareaPropertyType.Resize]: {
      type: String,
      default: TextAreaResizeType.None,
    },
    [TextareaPropertyType.Maxlength]: {
      type: Number,
      default: MAX_LENGTH,
    },
    [TextareaPropertyType.Minlength]: {
      type: Number,
      default: MIN_LENGTH,
    },
    [TextareaPropertyType.ColorScheme]: {
      type: String,
      default: StyleColorSchemeType.GrayLight,
    },
    [TextareaPropertyType.FillType]: {
      type: String,
      default: ControlStyleFillType.Outlined,
    },
    [TextareaPropertyType.Required]: {
      type: Boolean,
      default: false,
    },
    [TextareaPropertyType.Name]: {
      type: String,
      default: '',
    },
    [TextareaPropertyType.HasCharLimitHint]: {
      type: Boolean,
      default: false,
    },
  },
};

export default TextareaProps;
